<template>
  <div class="header-box fx">
    <img class="avatar" src="@/assets/image/avatar.png" alt="" srcset="" />
    <el-dropdown>
      <span style="margin-left:10px">【{{userInfo.role}}】 
        <span style="font-weight:600">{{userInfo.username}}</span>
      </span><i class="el-icon-arrow-down el-icon--right"></i>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-refresh-right" >
          <span @click="logout">退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    
  </div>
</template>

<script>
import router from '@/router';
import {
	storeLocal
} from '@/utils/storeLocal';
export default {
  data() {
    return {
      userInfo:{},
    };
  },
  methods: {
    logout(){
      storeLocal.remove("token");
      storeLocal.remove("user")
      router.replace('/login')
    }
  },
  components: {},
  mounted(){
    this.userInfo=storeLocal.get('user')
  },
};
</script>

<style scoped lang="less">
.header-box {
  height: 60px;
  align-items: center;
  justify-content: flex-end;
  .avatar {
    width: 32px;
    height: 32px;
  }
}
</style>
